module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login col-lg-12"
  }, [_c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "tab-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.signupConfirmError) ? _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "alert alert-danger alert-dismissible fade in",
    attrs: {
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.alertClose
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.signupConfirmError) + "\n                "), _c('br')])])]) : _vm._e(), _vm._v(" "), (_vm.signupConfirmsucess) ? _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "alert alert-success alert-dismissible fade in",
    attrs: {
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.alertClose
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('span', {
    staticClass: "fa fa-check"
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.signupConfirmsucess) + "\n\n\n              ")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('center', [_c('h6', {
    staticStyle: {
      "font-size": "2em"
    }
  }, [_vm._v("Welcome " + _vm._s(_vm.OrganizationName))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('center', [_c('h6', {
    staticStyle: {
      "color": "#9FAFD1"
    }
  }, [_vm._v("Please supply the following information in order to complete the signup process. ")])])], 1)]), _vm._v(" "), _c('div', [_c('el-form', {
    ref: "signupFormconfirm",
    attrs: {
      "model": _vm.signupFormconfirm,
      "rules": _vm.rules,
      "spellcheck": "false"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "First Name",
      "prop": "firstname"
    }
  }, [_c('el-input', {
    on: {
      "change": _vm.checkSpace
    },
    model: {
      value: (_vm.signupFormconfirm.firstname),
      callback: function($$v) {
        _vm.$set(_vm.signupFormconfirm, "firstname", $$v)
      },
      expression: "signupFormconfirm.firstname"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    attrs: {
      "span": 1
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Last Name",
      "prop": "lastname"
    }
  }, [_c('el-input', {
    on: {
      "change": _vm.checkSpace
    },
    model: {
      value: (_vm.signupFormconfirm.lastname),
      callback: function($$v) {
        _vm.$set(_vm.signupFormconfirm, "lastname", $$v)
      },
      expression: "signupFormconfirm.lastname"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Mobile Phone",
      "prop": "mobile"
    }
  }, [_c('el-input', {
    on: {
      "change": _vm.checkSpace
    },
    nativeOn: {
      "keypress": function($event) {
        return _vm.isNumber($event)
      }
    },
    model: {
      value: (_vm.signupFormconfirm.mobile),
      callback: function($$v) {
        _vm.$set(_vm.signupFormconfirm, "mobile", $$v)
      },
      expression: "signupFormconfirm.mobile"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('center', [_c('center', {
    staticStyle: {
      "color": "#9FAFD1"
    }
  }, [_vm._v("\n                  Please specify both an aquatic facility and aquatic venue. Later on you will be able to add more aquatic facilities and aquatic venues from the menu choice 'Settings>Manage Venue'.\n                ")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Aquatic Facility",
      "prop": "location"
    }
  }, [_c('el-input', {
    on: {
      "change": _vm.checkSpace
    },
    model: {
      value: (_vm.signupFormconfirm.location),
      callback: function($$v) {
        _vm.$set(_vm.signupFormconfirm, "location", $$v)
      },
      expression: "signupFormconfirm.location"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    attrs: {
      "span": 1
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Aquatic Venue",
      "prop": "pool"
    }
  }, [_c('el-input', {
    on: {
      "change": _vm.checkSpace
    },
    model: {
      value: (_vm.signupFormconfirm.pool),
      callback: function($$v) {
        _vm.$set(_vm.signupFormconfirm, "pool", $$v)
      },
      expression: "signupFormconfirm.pool"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_vm._v("\n                 \n              ")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    staticClass: "button button-block",
    on: {
      "click": function($event) {
        return _vm.submitForm('signupFormconfirm')
      }
    }
  }, [_c('span', [_vm._v("Submit")])])], 1)], 1)], 1)], 1)])]), _vm._v(" "), _c('center', [_c('version')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('h1', [_c('img', {
    attrs: {
      "src": require("../../assets/images/logo2.png")
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bb83a15"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/signupconfirm/signupconfirm.vue
// module id = 777
// module chunks = 1